import {useNavigate} from 'react-router';

import Button from 'components/Button';
import ReadableWidthTemplate from 'components/Templates/ReadableWidth';
import useModalService from 'components/shared/ModalService';
import {renderTechStackCell} from 'pages/public/companyTechStack/List';
import CommonQuestionsPage from 'pages/public/faq';
import {renderCommitFreqStats} from 'pages/public/github/list/Table';
import GitHubForm from 'pages/public/github/search/Form';
import MostRecentGitHubListPage from 'pages/public/github/search/List';
import WelcomePage from 'pages/public/welcome';
import './index.scss';



export default function GitHubSearchPage() {
  const modalService = useModalService();
  const navigate = useNavigate();

  const closeHandler = () => {
    modalService.close();
  };

  const clickHandler = (gitHubUsername, gitHubMetaData) => {
    modalService.close();
    navigate(`/github/profile/${gitHubUsername}`, {state: {gitHubMetaData}});
  };

  const saveHandler = (item) => {
    modalService.open({
      closeHandler,
      style: {
        width: '40em',
      },
      content: (
        renderGitHubStats(item, clickHandler)
      ),
    });
  };

  return (
    <ReadableWidthTemplate title="" className="gitHubPage">
      <WelcomePage />
      <GitHubForm onSave={saveHandler} />
      <MostRecentGitHubListPage />
      <CommonQuestionsPage />
    </ReadableWidthTemplate>
  );
}


function renderGitHubStats(item, clickHandler) {
  const {gitHubMetaData} = item.data;
  const {gitHubMetaDataId, gitHubUsername, languageStats, commitFreqStats} = gitHubMetaData;
  const languages = Object.keys(languageStats);
  const sortedLanguages = languages.sort((a, b) => languageStats[b] - languageStats[a]);
  const topUsageLanguages = sortedLanguages.slice(0, 3);
  return (
    <div key={gitHubMetaDataId} className="col-12">
      <div className="card h-100 bg-light text-dark rounded-5">
        <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
          <h5 className="card-title fs-5 fs-sm-6">{gitHubUsername}</h5>
          <p className="card-text mb-1 fs-5 fs-sm-6"><strong>Popular Languages:</strong></p>
          <ul className="list-unstyled">
            {renderTechStackCell({value: topUsageLanguages})}
          </ul>
          <p className="card-text mb-1 fs-5 fs-sm-6"><strong>Commit Activity Status:</strong></p>
          {renderCommitFreqStats({value: commitFreqStats})}
          <div className="text-center">
            <Button actionHandler={() => clickHandler(gitHubUsername, gitHubMetaData)} className="btn btn-primary mt-3">View Profile</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
